<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <WithholdingPeriods :cropTypeId="cropTypeId" />
    </div>
</template>

<script>
import currentUserQuery from '@views/WithholdingPeriods/Browse/queryCurrentUser.graphql';

import WithholdingPeriods from '../WithholdingPeriods/Browse.vue';

export default {
  name: 'WithholdingPeriodsContainer',

  components: {
    WithholdingPeriods,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['developer', 'admin', 'association'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  computed: {
    cropTypeId() {
      return this.$path.get(this, 'currentUser.managedAssociation.crop_type_id');
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
